import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="w-[92%] md:w-[88%] pt-5 mx-auto flex flex-col md:flex-row items-center gap-y-8 md:gap-x-[4%]">
        <div className="w-full md:w-[54%] text-center md:text-left">
          {/* Main Heading */}
          <h1 className="text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] font-bold pb-[2%] my-[0.67em] text-[#151515]">
            Shopify Plus Development Services in UAE
          </h1>

          {/* Description under heading */}
          <div className="text-left leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[10px] font-open space-y-4 w-full">
            <p>
              Growing brands need more than a basic online store. They need an
              ecommerce platform. It should manage large product catalogs. It
              must handle high traffic and support B2B operations. The platform
              should serve multiple markets and deal with complex business
              workflows. Shopify Plus is built for that level of growth.
            </p>
            <p>
              At Mean3, we provide Shopify Plus development services for
              businesses in the UAE. We help them grow their e-commerce
              operations. Our goal is to keep things simple and effective. If
              you are moving from another platform, upgrading from <a href="https://mean3.ae/shopify-website-development" className="blue-link">Shopify</a>, or
              starting a new store, we can help. Our team builds solutions that
              fit your goals.
            </p>
            <p>
              As a Shopify Plus agency in the UAE, we focus on building fast,
              secure, and easy-to-manage online stores. Our developers work
              with you. They want to understand your products, customers, and
              business processes. They do this before writing any code. The
              result is a Shopify Plus store that performs well today and
              supports your future growth.
            </p>
          </div>

          <p className="font-bold text-[#DA2128] text-base md:text-lg mb-[20px] font-open">
            Build a scalable Shopify Plus store with UAE-based experts.
          </p>

          <a
            href="/contact-mean3"
            className="inline-block py-[12px] px-[32px] bg-[#DA2128] rounded-[3px] font-bold text-white border-none leading-[1.15] mb-[30px] hover:bg-[#c01c22] transition-colors"
          >
            Get a Free Consultation Today
          </a>
        </div>

        <div className="w-full md:w-[42%]">
          <img
            src="/assets/Shopify Plus Development Services in UAE.webp"
            alt="Shopify Plus Development Services in UAE"
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Logos row stays same */}
      <div className="w-[90%] flex justify-center items-center flex-wrap section2-container mx-auto mt-[20px]">
        <div className="mx-5">
          <img
            className="w-[120px]"
            alt="Awards Logos"
            src="/assets/go-awards-logo.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[97px]"
            alt="Awards Logos"
            src="../../../../assets/award2.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[119px]"
            alt="Awards Logos"
            src="../../../assets/secp-logo.jpg"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[116px]"
            alt="Awards Logos"
            src="/assets/pasha-logo.jpg"
          />
        </div>
      </div>
    </div>
  );
}